import React from 'react'

export default props => (
  <svg viewBox="0 0 48 48" style={{ background: '#3c5a99' }} {...props}>
    <path
      fill="#fff"
      d="M33.118 48V29.412h6.24l.934-7.244h-7.174v-4.625c0-2.098.583-3.527 3.591-3.527l3.836-.002v-6.48c-.664-.087-2.94-.285-5.59-.285-5.531 0-9.317 3.377-9.317 9.576v5.343h-6.255v7.244h6.255V48z"
    />
  </svg>
)
